import { render, staticRenderFns } from "./OrdersFBMTableUserTableMobile.vue?vue&type=template&id=646ac9c0&scoped=true"
import script from "./OrdersFBMTableUserTableMobile.vue?vue&type=script&lang=js"
export * from "./OrdersFBMTableUserTableMobile.vue?vue&type=script&lang=js"
import style0 from "./OrdersFBMTableUserTableMobile.vue?vue&type=style&index=0&id=646ac9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646ac9c0",
  null
  
)

export default component.exports